/* eslint-disable no-undef */
export function getConfigSandbox() {
  if (process.env.STAGE === "prod") {
    const isSandbox = localStorage.getItem("sandbox");
    if (isSandbox === "true") {
      return {
        region: process.env.AWS_REGION,
        userPoolId: process.env.AWS_USER_POOL_ID,
        userPoolWebClientId: process.env.AWS_USER_POOL_WEB_CLIENT_ID,
      };
    }
  }
  return "";
}
